import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { DateConvert } from "utilities";
import { ModalSalesOrder } from "../../Section";

const InfoSection = ({ dataInfo }) => {
  const [modalSalesOrderConfing, setModalSalesOrderConfing] = useState({
    show: false,
    id: "",
  });
  const InfoItem = ({ title, value, link, onClick }) => (
    <tr>
      <td width={125}>{title}</td>
      <td className="pr-2">:</td>
      <td
        className={link && "text-primary"}
        style={link && { cursor: "pointer" }}
        onClick={onClick}
      >
        {value}
      </td>
    </tr>
  );

  const InfoItemVertical = ({ title, value }) => (
    <div className="mb-2">
      <small style={{ fontSize: 12 }} className="text-secondary">
        {title}
      </small>
      <div style={{ fontSize: 14 }}>{value}</div>
    </div>
  );

  return (
    <>
      <Row>
        <Col md={6} xs={6}>
          <table style={{ fontSize: 14 }}>
            <tbody>
              <InfoItem
                title="No. Sales Order"
                value={dataInfo.no_sales_order}
                link
                onClick={() =>
                  setModalSalesOrderConfing({
                    show: true,
                    id: dataInfo?.id_sales_order,
                  })
                }
              />
              <InfoItem
                title="No. Delivery Order"
                value={dataInfo.no_delivery_order}
              />
              {/* <InfoItem title="Gudang" value={dataInfo.gudang} /> */}
            </tbody>
          </table>
        </Col>
        <Col md={6} xs={6}>
          <table style={{ fontSize: 14 }}>
            <tbody>
              <InfoItem title="Customer" value={dataInfo.customer} />
              <InfoItem title="Sales" value={dataInfo.sales} />
              <InfoItem title="Proyek" value={dataInfo.nama_proyek} />
              <InfoItem
                title="Tgl. Batas Waktu"
                value={
                  dataInfo.tgl_batas_waktu
                    ? DateConvert(new Date(dataInfo.tgl_batas_waktu)).detail
                    : "-"
                }
              />
            </tbody>
          </table>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={6} xs={6}>
          <InfoItemVertical
            title="Tgl. Surat Jalan"
            value={
              dataInfo.tgl_surat_jalan
                ? DateConvert(new Date(dataInfo.tgl_surat_jalan)).detail
                : "-"
            }
          />
        </Col>
        <Col md={6} xs={6}>
          <InfoItemVertical
            title="No. Surat Jalan"
            value={dataInfo.no_surat_jalan}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6} xs={6}>
          <InfoItemVertical
            title="Petugas Pengiriman"
            value={dataInfo.petugas_pengiriman}
          />
        </Col>
        <Col md={6} xs={6}>
          <InfoItemVertical
            title="Armada Pengiriman"
            value={dataInfo.armada_pengiriman}
          />
        </Col>
      </Row>
      {modalSalesOrderConfing.show && (
        <ModalSalesOrder
          setModalConfig={setModalSalesOrderConfing}
          modalConfig={modalSalesOrderConfing}
        />
      )}
    </>
  );
};

export default InfoSection;
